import React, { useContext, useEffect, useState, useRef } from "react";
import "./style.scss";
import FlowEdit from "../../assets/Header/FlowEdit.svg";
import UserProfile from "../../assets/Header/userProfile.svg";
import SettingsIcon from "../../assets/Header/Settings.svg";
import Notification from "../../assets/Header/Notification.svg";
import { Avatar, Progress, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useUpload } from "../../context/uploadFileContext";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { SignInApi } from "../../apis/SignIn";
import { useLogoutUser } from "../../hooks/useSeggregation";
import { BatchMarketPlaceContext } from "../../context/batchProvider";
import { SeggreagtionContext } from "../../context/seggregationProvider";
import wallet from "../../assets/Header/wallet.svg";
import chevron from "../../assets/Header/chevron.svg";
import { UserWalletContext } from "../../context/userWalletContext";
import { SourceProviderContext } from "../../context/sourceProvider";

const Header = ({ openWallet, setOpenWallet }) => {
  const [logo, setLogo] = useState();
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(true);
  const [isImageError, setIsImageError] = useState(false);
  const { batch_setSkipPages } = useContext(BatchMarketPlaceContext);
  const navigate = useNavigate();
  const { uploadedFolders } = useUpload();
  const { segg_logoutPayload } = useContext(SeggreagtionContext);
  const [expand, setExpand] = useState(false);
  const { setOpenRechargeWalletModal } = useContext(UserWalletContext);
  const [showContent, setShowContent] = useState(false);
  const { walletDetails, getWalletAccountDetails } =
    useContext(UserWalletContext);
  const { setSourceData } = useContext(SourceProviderContext);
  const rechargeRef = useRef(null);
  const priceRef = useRef(null);
  const rechargeTextRef = useRef(null);
  const handleLogout = () => {
    if (segg_logoutPayload) {
      logoutUser(segg_logoutPayload);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
  };
  const onSuccessLogout = (res) => {
    if (res.status === 200) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
  };
  const onErrorLogout = () => {};
  const { mutate: logoutUser } = useLogoutUser(onSuccessLogout, onErrorLogout);

  useEffect(() => {
    getWalletAccountDetails();
    async function fetchData() {
      try {
        const userResponse = await SignInApi.getSource("");
        if (userResponse.status === 200) {
          setSourceData(userResponse?.data);
          setLogo(userResponse?.data?.imageAssets?.brandImage?.imagePath?.url);
          setIdentifier(userResponse?.data?.identifier);
          batch_setSkipPages(userResponse?.data?.skipPage);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleTransitionEnd = (event) => {
    if (event.propertyName === "width") {
      const rechargeElement = rechargeRef.current;
      const priceElement = priceRef.current;
      const rechargeTextElement = rechargeTextRef.current;

      if (
        rechargeElement &&
        priceElement &&
        rechargeTextElement &&
        rechargeElement.classList.contains("expanded") &&
        rechargeElement.offsetWidth === 180
      ) {
        priceElement.style.opacity = "1";
        rechargeTextElement.style.opacity = "1";
      } else if (priceElement && rechargeTextElement) {
        priceElement.style.opacity = "0";
        rechargeTextElement.style.opacity = "0";
      }
    }
  };

  return (
    <div className="header_main_wrapper">
      <div className="header_content">
        {!loading && identifier !== "flowedit" && (
          <div className="source_logo">
            Designed for{" "}
            <div className="logo_wrapper">
              <img src={logo} alt="" />
            </div>
          </div>
        )}
        <div className="right_wrapper">
          <div
            className={`recharge ${expand ? "collapsed" : "expanded"}`}
            ref={rechargeRef}
            onMouseOver={() => setShowContent(true)}
            onMouseOut={() => setShowContent(false)}
            onTransitionEnd={handleTransitionEnd}
          >
            <div
              className={`chevron_icon ${expand ? "rotated" : ""}`}
              onClick={() => setExpand(!expand)}
            >
              <img src={chevron} alt="Chevron Icon" />
            </div>
            <span className="price">
              <img src={wallet} alt="Wallet Icon" />
              <p ref={priceRef}>
                $
                {(
                  Number(walletDetails?.availableBalance?.unitAmount || 0) -
                  Number(walletDetails?.blockedAmount?.unitAmount || 0)
                ).toFixed(2)}{" "}
              </p>
            </span>
            <button
              className="recharge_text"
              onClick={() => setOpenRechargeWalletModal(true)}
              ref={rechargeTextRef}
            >
              Recharge Wallet
            </button>
            {showContent && (
              <div className="content_container">
                {
                  <>
                    <p className="wallet_text">
                      Current Wallet Amount :{" "}
                      <span>
                        $
                        {(walletDetails?.availableBalance?.unitAmount).toFixed(
                          2
                        )}
                      </span>{" "}
                      <br />
                      Blocked Amount :{" "}
                      <span>
                        $
                        {(walletDetails?.blockedAmount?.unitAmount).toFixed(
                          2
                        ) || 0}
                      </span>
                    </p>
                    <div>
                      <button onClick={() => navigate("/billing")}>
                        View Transaction History
                      </button>
                    </div>
                  </>
                }
              </div>
            )}
          </div>
          {uploadedFolders?.find((folder) => folder.memory.uploading) && (
            <div className="image_upload_progress">
              <Progress
                type="circle"
                percent={
                  uploadedFolders.find((folder) => folder.memory.uploading)
                    .memory.progress
                }
                size={40}
                strokeColor={"#3B60E4"}
                trailColor="#fafafa"
              />
              <div className="text">uploaded</div>
            </div>
          )}
          {/* <div className="settings_icon_wrapper">
            <img src={SettingsIcon} alt="settingsIcon" />
          </div>
          <div className="notification_wrapper">
            <img src={Notification} alt="notification" />
          </div> */}
          <div
            className="user_profile_wrapper"
            // onClick={() => setShowLogout(!showLogout)}
          >
            {!isImageError && localStorage.getItem("user_picture") ? (
              <img
                src={localStorage.getItem("user_picture")}
                alt="User Profile"
                onError={() => setIsImageError(true)}
              />
            ) : (
              <Avatar size={40} icon={<UserOutlined />} />
            )}
          </div>
          <button className="logoutBtn" onClick={handleLogout}>
            <LogoutOutlined style={{ fontSize: "20px" }} />
          </button>
        </div>
        {/* {showLogout && (
          <div className="logout_wrapper">
            <Button
              text="Logout"
              height="40px"
              width={"100px"}
              handleClick={handleLogout}
            />
          </div>
        )} */}
      </div>
    </div>
  );
};
export default Header;
